<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <el-breadcrumb-item>物流列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row
        >物流计费参数【最小计费重量：{{ wuliuForm.minWeight }} 埠内单价：{{ wuliuForm.buInPrice }} 埠外单价：{{ wuliuForm.buOutPrice }} 省外单价：{{ wuliuForm.swprice }} 不到最小重量的运费：{{ wuliuForm.limitPrice }}
        】
        <el-button type="primary" @click="goSetOrderSetInfo" v-if="canLook == 1">设置物流计费参数</el-button>
      </el-row>
      <!--       
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入订单号" v-model="queryInfo.query" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="getOrderList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl">
            <el-button size="mini" type="info">导出订单</el-button>
          </a>
        </el-col>
      </el-row> -->

      <el-row :gutter="20">
        <el-col :span="5">
          <el-input placeholder="请输入订单号" v-model="queryInfo.order_id" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-input placeholder="请输入经销商名称" v-model="queryInfo.agencyName" clearable @clear="getOrderList">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="block aaaa">
            <el-date-picker
              v-model="queryInfo.time"
              @change="timechange"
              type="daterange"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div>
        </el-col>

        <el-col :span="4" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl + '&time=' + JSON.stringify(queryInfo.time) + '&status=' + queryInfo.status + '&order_id=' + queryInfo.order_id + '&agencyName=' + queryInfo.agencyName">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <!-- 订单列表数据 -->
      <el-table id="out-table" :data="orderlist" border stripe ref="multipleTable" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" fixed> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="商品信息" type="expand">
          <template slot-scope="scope">
            <el-table :data="scope.row.goods_info" border stripe ref="xxxTable" tooltip-effect="dark">
              <el-table-column label="商品名称" prop="goodinfo.title" width="180px"> </el-table-column>
              <el-table-column label="商品编号" prop="goodinfo.number" width="70px"> </el-table-column>
              <el-table-column label="商品重量" prop="goodinfo.weight" width="70px"> </el-table-column>
              <el-table-column label="购买数量" prop="goodinfo.buyNum" width="70px"> </el-table-column>
              <el-table-column label="赠送数量" prop="goodinfo.sendNumber" width="70px"> </el-table-column>
              <el-table-column label="活动" prop="activityContent" width="120px"> </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column label="订单号" prop="order_id" width="150px"></el-table-column>
        <el-table-column label="下单经销商" prop="agencyName" width="130px"></el-table-column>

        <!-- <el-table-column label="订单总价" prop="order_amount_total" align="center" width="60px"> </el-table-column> -->
        <el-table-column label="订单状态" prop="order_status" width="120px">
          <!-- 全部-1 待支付0 待确认1 ,待发货2,已发货3 ,已完成4, 退款5 取消6 -->
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.order_status == '0'">未付款</el-tag>
            <el-tag class="daiqueren" v-if="scope.row.order_status == '1'">待确认</el-tag>
            <el-tag class="daifahuo" v-if="scope.row.order_status == '2'">待发货</el-tag>
            <el-tag class="yifahuo" v-if="scope.row.order_status == '3'">已发货</el-tag>
            <el-tag type="success" v-if="scope.row.order_status == '4'">已完成</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '0'">退款中，待确认</el-tag>
            <el-tag type="danger" v-if="scope.row.order_status == '5' && scope.row.tuikuanStatus == '1'">退款成功</el-tag>
            <el-tag type="info" v-if="scope.row.order_status == '6'">已取消</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="发货时间" prop="send_at" width="130px"> </el-table-column>
        <el-table-column label="总重量" prop="total_weight" align="center" width="60px"> </el-table-column>
        <el-table-column label="总数量" prop="totalNum" align="center" width="60px"> </el-table-column>
        <el-table-column label="运费" prop="yunfei" align="center" width="60px"> </el-table-column>
        <el-table-column label="区域" prop="quyu" align="center" width="90px"> </el-table-column>

        <el-table-column label="操作" width="250px" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editOrder(scope.row.order_id)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteOrder(scope.row.order_id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 修改地址的对话框 -->
    <el-dialog title="修改计量信息" :visible.sync="wuliuVisible" width="50%" @close="wuliuDialogClosed">
      <div>修改将影响后面的发货订单计算物流费用，不影响之前已发货的订单</div>
      <el-form :model="wuliuForm" :rules="wuliuFormRules" ref="wuliuFormRef" label-width="100px">
        <el-form-item label="最小计量重量（kg）" prop="minWeight">
          <el-input v-model="wuliuForm.minWeight"></el-input>
        </el-form-item>
        <el-form-item label="埠内单价" prop="buInPrice">
          <el-input v-model="wuliuForm.buInPrice"></el-input>
        </el-form-item>
        <el-form-item label="埠外单价" prop="buOutPrice">
          <el-input v-model="wuliuForm.buOutPrice"></el-input>
        </el-form-item>
        <el-form-item label="省外单价" prop="swprice">
          <el-input v-model="wuliuForm.swprice"></el-input>
        </el-form-item>
        <el-form-item label="不到最小重量的运费" prop="limitPrice">
          <el-input v-model="wuliuForm.limitPrice"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wuliuVisible = false">取 消</el-button>
        <el-button type="primary" @click="wuliuDialogSure()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      canLook: 1,
      exportUrl: 'https://hsznttghpt.hsxsn.cn/wuliuExportExcel?mPhone=' + localStorage.getItem('phone'),
      queryInfo: {
        order_id: '',
        agencyName: '',
        time: null,
        type: 0,
        pagenum: 1,
        pagesize: 10
      },

      statusValue: '全部',
      statusOptions: [
        { value: '全部', id: -1 },
        { value: '待确认', id: 1 },
        { value: '待发货', id: 2 },
        { value: '已发货', id: 3 },
        { value: '已完成', id: 4 },
        { value: '退款', id: 5 },
        { value: '已取消', id: 6 },
      ],
      typeValue: '全部',
      typeOptions: [
        { value: '全部', id: 0 },
        { value: '常温', id: 1 },
        { value: '低温', id: 2 },
      ],

      total: 0,
      orderlist: [],
      wuliuSetInfo: null,//物流设置信息
      wuliuVisible: false,
      wuliuForm: {
        minWeight: null,
        buInPrice: null,
        buOutPrice: null,
        limitPrice: null,
      },
      wuliuFormRules: {
        minWeight: [
          { required: true, message: '请输入最小计费重量', trigger: 'blur' }
        ],
        buInPrice: [
          { required: true, message: '请填写埠内计费单价', trigger: 'blur' }
        ],
        buOutPrice: [
          { required: true, message: '请填写埠外计费单价', trigger: 'blur' }
        ],
        limitPrice: [
          { required: true, message: '请填写不到最小重量的运费', trigger: 'blur' }
        ]
      },

      progressVisible: false,
      progressInfo: [],
      multipleSelection: [],
      multipleSelectionjson: null,
    }
  },

  created () {
    this.getOrderList()
    this.getWuliuSetInfo()
  },

  methods: {
    // 设置物流参数
    goSetOrderSetInfo () {
      this.wuliuVisible = true
    },

    wuliuDialogClosed () {
      this.$refs.wuliuFormRef.resetFields()
    },

    async wuliuDialogSure () {
      this.$refs.wuliuFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await this.$http.post('/admin/order/setOrderSet', this.wuliuForm)
        if (res.code !== 200) {
          return this.$message.error('操作失败！')
        }
        this.$message.success('操作成功！')
        this.wuliuVisible = false
        this.getWuliuSetInfo()
      })
    },

    async getWuliuSetInfo () {
      const { data: res } = await this.$http.get('/admin/order/getOrderSet')
      if (res.code !== 200) {
        return this.$message.error('获取失败！')
      }
      console.log(res.result);
      this.wuliuForm = res.result
    },

    // 编辑
    editOrder (id) {
      console.log(id);
      this.$router.push({ path: '/orders/detail', query: { id: id } })
    },

    // 删除
    async deleteOrder (id) {
      const confirmResult = await this.$confirm(
        '订单删除后将不可找回,是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/delete', {
        id: id,
      })
      if (res.code !== 200) {
        return this.$message.error('删除订单失败！')
      }
      this.$message.success('删除订单成功！')
      this.getOrderList()
    },

    search () {
      this.filterSelect();
    },

    timechange (e) {
      this.filterSelect();
    },

    filterSelect () {
      this.total = 0
      this.queryInfo.pagenum = 1
      this.orderlist = []
      this.getOrderList()
    },

    // 多选选择的项
    handleSelectionChange (val) {
      this.multipleSelection = val;
      var list = [];
      val.forEach(element => {
        list.push({ 'id': element.id });
      });
      if (list.length > 0) {
        this.multipleSelectionjson = JSON.stringify(list);
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/wuliuExportExcel?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsznttghpt.hsxsn.cn/wuliuExportExcel?mPhone=' + localStorage.getItem('phone')
      }
    },

    // 批量确认订单 确认1 ,发货2,已完成3, 取消6
    async sureOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将确认所有已选中的待确认订单，其余订单确认无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 1,
      })
      if (res.code !== 200) {
        return this.$message.error('确认订单失败！')
      }
      this.$message.success('确认订单成功！')
      this.getOrderList()
    },

    // 批量发货订单
    async sendOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将发货所有已选中的已确认订单，其余订单发货无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 2,
      })
      if (res.code !== 200) {
        return this.$message.error('订单发货失败！')
      }
      this.$message.success('订单发货成功！')
      this.getOrderList()
    },

    // 批量完成订单
    async completeOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '将所有已选中的已发货订单，其余订单完成无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 3,
      })
      if (res.code !== 200) {
        return this.$message.error('订单已完成操作失败！')
      }
      this.$message.success('订单已完成操作成功！')
      this.getOrderList()
    },

    // 批量取消订单
    async cancelOrder () {
      if (this.multipleSelection == null || this.multipleSelection.length == 0) {
        return this.$message.info('请先勾选订单！')
      }
      const confirmResult = await this.$confirm(
        '只能取消待支付和待确认的订单，其余订单取消无效, 是否继续?',
        '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('取消操作！')
      }
      const { data: res } = await this.$http.post('admin/order/changeOrdersStatus', {
        data: this.multipleSelection,
        type: 6,
      })
      if (res.code !== 200) {
        return this.$message.error('订单取消操作失败！')
      }
      this.$message.success('订单取消操作成功！')
      this.getOrderList()
    },

    async getOrderList () {
      const { data: res } = await this.$http.get('admin/order/getWuliuOrderList', {
        params: this.queryInfo
      })
      if (res.code !== 200) {
        return this.$message.error('暂无物流信息记录！')
      }
      console.log(res)
      this.total = res.result.count
      this.orderlist = res.result.list
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    exportOrder () {
      this.getOrderList()
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getOrderList()
    },

    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getOrderList()
    },
  }
}
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
.el-table .cell {
  white-space: pre-line;
}
.el-row {
  margin-top: 10px;
}

.daiqueren {
  background-color: aquamarine;
}

.daifahuo {
  background-color: rgb(242, 255, 127);
}
.yifahuo {
  background-color: rgb(8, 27, 133);
}

.aaaa {
  margin-left: 10px;
}

.daochuA {
  width: 60px;
  height: 24px;
  line-height: 24px;
  align-items: center;
  background-color: blue;
  color: #fff;
  align-content: center;
  margin-left: 20px;
  display: inline-block;
  padding: 20rpx;
  font-size: 14px;
  text-decoration: none;
}
</style>
